<template>
    <div class="panel-search" v-bind:class="{ 'dropdown-menu-open': dropDownOpen}">
        <input
            :name="name"
            type="text"
               v-model="searchText"
               :placeholder="'Введите город'"
               :class="['input-text', {'input-error': hasErrors}]"
               @input="onSearchInput"
               @blur="onBlur"
               @focus="onFocus"
               autocomplete="off"
               :disabled="disabled"
        />
        <div v-if="true" class="dropdown-menu dropdown-list" style="max-width: 100%;">
            <a
                class="dropdown-menu-item"
                v-for="(item, index) in filteredCities"
                :key="index"
                @click="onSelectCity(item)">
                <span>{{ item.Name }}</span>
            </a>
        </div>
    </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
    name: "city-search",

    props: ['name', 'selectedCity', 'hasErrors', 'disabled'],

    $_veeValidate: {
              value () {
                  return this.searchText;
              },
              name () {
                  return this.name;
              }
          },

    data() {
        return {
            searchText: this.selectedCity ? this.selectedCity.Name : '',
            filteredCities: [],
            dropDownOpen: false,
            citiesData: [], // данные с городами
        };
    },

    methods: {
        // Метод фильтрации городов
        filterCities(searchText) {
            return this.citiesData.filter(city =>
                city.city.toLowerCase().includes(searchText.toLowerCase()) ||
                city.region.toLowerCase().includes(searchText.toLowerCase())
            ).map(city => ({
                Name: `${city.city}, ${city.region}`,
                Id: `${city.city}, ${city.region}`,
            }));
        },

        // Дебаунс для поиска
        onSearchInput: debounce(function() {
            if (this.searchText) {
                this.filteredCities = this.filterCities(this.searchText);
                this.dropDownOpen = this.filteredCities.length > 0;
            } else {
                this.filteredCities = [];
                this.dropDownOpen = false;
            }
        }, 500),

        // Обработка выбора города
        onSelectCity(item) {
            this.searchText = item.Name;
            this.dropDownOpen = false;
            this.$emit('update:selectedCity', item);
        },

        // Событие при фокусе
        onFocus() {
            if (!this.searchText) {
                this.filteredCities = [];
            }
            this.dropDownOpen = true;
        },

        // Событие при потере фокуса
        onBlur() {
            setTimeout(() => {
                this.dropDownOpen = false;
            }, 100);
        },
    },

    watch: {
        selectedCity(newVal) {
            if (newVal) {
                this.searchText = newVal.Name;
            } else {
                this.searchText = '';
            }
        }
    },

    mounted() {
        this.citiesData = require('../cities.json');
    },
};
</script>

<style scoped>
/* Ваши стили */
</style>



// WEBPACK FOOTER //
// Content/src/components/CitySearch.vue